import React from "react";
import { useSelector } from "react-redux";
import showdown from "showdown";
import classnames from "classnames";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  const converter = new showdown.Converter();
  const subtitle = converter.makeHtml(
    currentActivity.websiteData.challenges.subtitle
  );
  return (
    <>
      {currentActivity &&
        currentActivity.websiteData &&
        currentActivity.websiteData.challenges &&
        currentActivity.websiteData.challenges.data &&
        currentActivity.websiteData.challenges.data.length > 0 && (
          <div
            id="challenge"
            className="gradiant-background pwg-section features-section pb-100 section imgcenter"
          >
            <div className="container tab-fix">
              <div className="section-head heading-light text-center">
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <h2 className="heading heading-light">
                      {currentActivity.websiteData.challenges.title
                        ? currentActivity.websiteData.challenges.title
                        : "Challenges"}
                    </h2>
                    {currentActivity.websiteData.challenges.subtitle && (
                      <p
                        className="h4 heading-light"
                        dangerouslySetInnerHTML={{ __html: subtitle }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="features-content justify-content-around">
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    textAlign: "center",
                  }}
                >
                  {currentActivity.websiteData.challenges.data.map(
                    (challenge, index) => {
                      const title = converter.makeHtml(challenge.title);
                      const description = converter.makeHtml(
                        challenge.description
                      );
                      return (
                        <div
                          key={index}
                          className={classnames(
                            {
                              "col-md-6 col-sm-10":
                                currentActivity.websiteData.challenges.data
                                  .length %
                                  2 ===
                                0,
                            },
                            {
                              "col-md-4 col-sm-10":
                                currentActivity.websiteData.challenges.data
                                  .length %
                                  2 !==
                                0,
                            }
                          )}
                        >
                          <div className="ld-flipbox">
                            <div
                              className="ld-flipbox-wrap"
                              style={{ padding: 20 }}
                            >
                              <div
                                className="ld-flipbox-face ld-flipbox-front backgroundwhite"
                                style={{
                                  backgroundColor: "#fff",
                                  borderRadius: "8px",
                                }}
                              >
                                <span className="ld-flipbox-overlay ld-overlay bg-fade-dark-045" />
                                <div
                                  className="box ld-flipbox-inner py-6"
                                  style={{ height: 230 }}
                                >
                                  <img
                                    src={challenge.icon}
                                    alt="software"
                                    style={{ width: 140 }}
                                  />
                                </div>
                              </div>

                              <div className="ld-flipbox-face ld-flipbox-back backgroundwhite">
                                <span className="ld-flipbox-overlay ld-overlay" />

                                <div className="ld-flipbox-inner">
                                  <p style={{ textAlign: "justify" }}>
                                    <span
                                      className="btn-txt black"
                                      style={{ fontSize: 12 }}
                                      dangerouslySetInnerHTML={{
                                        __html: description,
                                      }}
                                    />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <h4
                            className="whitetxt mb-2 heading-light"
                            dangerouslySetInnerHTML={{
                              __html: title,
                            }}
                          ></h4>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      {false && (
        <div
          id="easyinstall"
          className="section steps-section pbm-0"
          style={{ backgroundColor: "#638b18" }}
        >
          <div className="container">
            <div className="section-head heading-light text-center">
              <div className="row">
                <div className="col-md-8 col-md-offset-2">
                  <h2 className="heading whitetxt">
                    À qui voulons-nous faciliter la vie ?
                  </h2>
                </div>
              </div>
            </div>
            <div className="row tab-center mobile-center row-vm ">
              <div className="col-md-8 col-md-offset-2">
                <div className="txt-entry txt-feature text-center ">
                  <p className="mb-4 whitetxt" style={{ textAlign: "justify" }}>
                    - <b>Retraités</b> : extraits interview du président de
                    l’association pour illustrer problématique challenge :
                    #Hack_Contrôle_Existence <br />- <b> Pensionnaires </b>qui
                    ont été victimes de maladie ou d’accident de travail.
                  </p>
                  <a
                    className="button solid-btn sb-h"
                    href={`https://applyforms.lafactory.co/${currentActivity._id}/`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      backgroundColor: "#313e48",
                      color: "white",
                    }}
                  >
                    S'INSCRIRE
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
